angular.module('picmonicng').directive('learnSafetyModeOverlay', [
  function () {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<div ng-if="safetyOverlayVisible" class="learn-safety-mode-overlay">' +
        '<img class="learn-safety-mode-title" pls-src="/assets/img/learn/safety-mode-title.svg" alt="This Picmonic Contains Sensitive Content" />' +
        '<maturity-rating ></maturity-rating>' +
        '<div class="text-center pls-white">Would you still like to view it?<br/><br/><button class="pls-btn pls-btn--outline-white learn-safety-mode-button" ng-click="hide()">Override Safety Mode & View</button></div>' +
        '</div>',
      controller: [
        '$scope',
        'LearnService',
        'UserService',
        function ($scope, LearnService, UserService) {
          $scope.safetyOverlayVisible = LearnService.currentCard.is_mature && UserService.user.safety_mode;

          $scope.$watch(
            function () {
              return LearnService.currentCard.card_id;
            },
            function (newVal) {
              $scope.safetyOverlayVisible = LearnService.currentCard.is_mature && UserService.user.safety_mode;
            }
          );

          $scope.hide = function () {
            $scope.safetyOverlayVisible = false;
          };

          $scope.$on('safetyModeToggle', function () {
            $scope.safetyOverlayVisible = LearnService.currentCard.is_mature && UserService.user.safety_mode;
          });
        },
      ],
    };
  },
]);
